export const PRODUCT_SUMMARY_TEST_IDS = {
  BLOCK: 'product-summary-block-test-id',
  RATES_LIST: 'rates-list-test-id',
  RATES_ITEM: 'rates-item-test-id',
  RATE_VALUE: 'rate-value-test-id',
  NOT_ELIGIBLE_RATES: 'not-eligible-rates-test-id',
  EMPTY_BROWSING_CRITERIA_BLOCK: 'empty-browsing-criteria-block-test-id',
  EXISTING_BROWSING_CRITERIA_BLOCK: 'existing-browsing-criteria-block-test-id',
  BROWSING_CRITERIA_TEXT: 'browsing-criteria-text-test-id',
  NOT_ELIGIBLE_BROWSING_CRITERIA: 'not-eligible-browsing-criteria-test-id',
};

export const RATES_COMPARISON_CARD_TEST_IDS = {
  CARD_WRAPPER: 'rates-comparison-card-wrapper-test-id',
  TITLE_INFO_WRAPPER: 'rates-comparison-card-title-info-wrapper-test-id',
  PRODUCT_NAME: 'rates-comparison-card-product-name-test-id',
  RATES_BLOCK: 'rates-comparison-card-rates-block-test-id',
};

export const DATA_TEST_IDS = {
  UW_STATUS_TAG: 'uw-status-tag',
};
